<template>
    <div :class="{'mt-3':!this.isMultipleOption}">
        <div class="row" role="group">
            <div class="col-md-12" v-for="(choice, index) in choices" :key="index">
                <div class="form-check">
                    <label class="form-check-label" :for="name + index" :class="[fieldInnerClass, {disabled: choice.value != 'none' && selectedValues.includes('none'), 'fs-5': !!this.isMultipleOption}]">
                        <input v-if="!!this.isMultipleOption" class="form-check-input" type="checkbox"
                            :name="name" :id="name + index"
                            :value="choice.value"
                            :key="choice.value"
                            :disabled="choice.value != 'none' && selectedValues.includes('none')"
                            :checked="selectedValues.includes(choice.value)"
                            @change="this.handleChanges(choice, $event)"
                        />
                        <input v-else class="form-check-input" type="checkbox"
                            :name="name" :id="name + index"
                            :true-value="true"
                            :false-value="false"
                            v-model="custom"
                            :checked="value === true"
                        />
                        <span v-html="this.getTranslatedText(choice.text, 'fields.options')"></span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {inject} from "vue";

export default {
    props: ["choices","value","name","label","fieldInnerClass","isMultipleOption"],
    emits: ["update:model-value","input"],
    setup() {
        const { getTranslatedText } = inject('app'); // app is being provided in Application.vue
        return { getTranslatedText }
    },
    data() {
        return {
            selectedValues: []
        }
    },
    computed: {
        custom: {
            get(){ return this.value },
            set(v){ this.$emit('input', v) }
        }
    },
    methods: {
        handleChanges(choice, event) {
            if (choice.value == "none") {
                this.selectedValues = event.target.checked ? ['none'] : [];
            } else {
                if (event.target.checked) {
                    this.selectedValues = this.selectedValues.filter((v) => v != "none");
                    this.selectedValues.push(choice.value);
                } else {
                    this.selectedValues = this.selectedValues.filter((v) => v != choice.value);
                }
            }
            this.$emit("input", this.selectedValues.length == 0 ? null : this.selectedValues);
        }
    },
    watch: {
    }
}
</script>
<style scoped>

.form-check .disabled {
    cursor: not-allowed;
    opacity: .5;
}


.large-checkbox .form-check-input {}
.large-checkbox span {}

@media (min-width: 768px) {
    .large-checkbox .form-check-input {
        width: 30px;
        height: 30px;
        margin: 5px 10px 50px auto;
    }
    .large-checkbox span {
        font-size: 14px;
    }
}

</style>
